<template>
  <div class="example-preview table-responsive overflow-auto">
    <table class="table table-hover table-bordered table-vertical-center b-table" style="text-align: center">
      <thead style="border: 1px solid lightgray">
      <tr>
        <th scope="col" class="min-w-60px">Số công trừ</th>
        <th scope="col" class="min-w-100px">Lớp</th>
        <th scope="col" class="min-w-100px">Lý do</th>
        <th scope="col" class="min-w-100px">Giảng viên</th>
        <th scope="col" class="min-w-120px">Hành động</th>
      </tr>
      </thead>
      <tbody v-if="deductionList?.length > 0">
      <tr v-for="item in deductionList" :key="item.id">
        <td>{{ item?.number ?? '' }}</td>
        <td><span style="word-break: break-word">{{ item?.classroom_name ?? '' }}</span></td>
        <td><span style="word-break: break-word">{{ item?.reason ?? '' }}</span></td>
        <td><span style="word-break: break-word">{{ item?.teacher_name ?? '' }}</span></td>
        <td>
          <el-button size="small" @click="confirmDeleteDeduction(item)" class="btn btn-xs btn-outline-danger">
            <i class="el-icon-delete" style="width: 13px; height: 15px;"></i>
          </el-button>
        </td>
      </tr>
      </tbody>
      <tbody v-else>
      <tr style="text-align: center">
        <td :colspan="5">Chưa có dữ liệu</td>
      </tr>
      </tbody>
    </table>
    <el-dialog
        class="responsive" v-if="isDelete" width="30%"
        :visible.sync="isDelete" :show-close="false"
        append-to-body :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
      <template #title>
        <span style="width: 100%; text-align: start; display: block; font-size: 20px; font-weight: 700">Xác nhận xoá công {{ lesson?.lesson ? `buổi ${lesson?.lesson}` : '' }} {{ classroom?.classroom_name ? `lớp ${classroom?.classroom_name}` : '' }}</span>
      </template>
      <hr style="margin-top: -25px"/>
      <div style="width: 100%; text-align: start; word-break: break-word">
        Bạn có chắc chắn muốn xoá công {{ lesson?.lesson ? `buổi ${lesson?.lesson}` : '' }} {{ classroom?.classroom_name ? `lớp ${classroom?.classroom_name}` : '' }} không?
      </div>
      <div style="display: flex; justify-content: end; gap: 8px; margin-top: 20px">
        <el-button type="info">Hủy</el-button>
        <el-button @click="handleDeleteDeduction" :disabled="loading" v-loading="loading" type="primary">Xác nhận</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {DELETE_DEDUCTION} from "@/core/services/store/course/classes.module";

export default {
  name: 'TableDeduction',
  props: {
    deductionList: {
      type: Array,
      required: true,
      default: []
    },
    lesson: {
      type: Object,
      default: null
    },
    classroom: {
      type: Object,
      default:null
    }
  },
  data() {
    return {
      isBusy: false,
      isDelete: false,
      loading: false,
    }
  },
  methods: {
    confirmDeleteDeduction(deduction) {
      this.isDelete = true
      this.deductionSelected = deduction
    },
    handleDeleteDeduction() {
      this.loading = true
      this.$store.dispatch(DELETE_DEDUCTION, this.deductionSelected.id).then(res => {
        if (!res.error) {
          this.$emit('GetListDeduction')
          this.$message.success('Xoá bản ghi thành công !')
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.isDelete = false
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>